import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
